import { motion } from "framer-motion";
import { Phone, Mail, Globe2 } from "lucide-react";

const LOGO_URL = "https://i.ibb.co/3y7zpmrq/Gemini-Generated-Image-e6u2kle6u2kle6u2-1-1-removebg-preview.png";

export const Footer = () => {
  const scrollTo = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer data-testid="footer" className="bg-brand-navy text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
            <img src={LOGO_URL} alt="Duali Soluções" className="h-16 w-auto mb-4 brightness-0 invert" />
            <p className="text-sm text-slate-400 leading-relaxed max-w-xs">Soluções estratégicas em Benefícios e Seguros. Mais de 30 anos transformando o mercado brasileiro.</p>
            <div className="mt-4"><p className="text-xs text-slate-500">CNPJ: 25.433.372/0001-32</p></div>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }}>
            <h4 className="text-base font-bold mb-6">Navegação</h4>
            <div className="space-y-3">
              {[{l:"Sobre Nós",h:"#sobre"},{l:"Oportunidade",h:"#oportunidade"},{l:"Pilares",h:"#pilares"},{l:"Serviços",h:"#servicos"},{l:"Valores",h:"#valores"},{l:"Contato",h:"#contato"}].map((link) => (
                <button key={link.h} onClick={() => scrollTo(link.h)} className="block text-sm text-slate-400 hover:text-brand-teal transition-colors duration-300">{link.l}</button>
              ))}
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.2 }}>
            <h4 className="text-base font-bold mb-6">Contato</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3"><Phone className="text-brand-teal mt-0.5 shrink-0" size={16} /><a href="tel:+5511998686751" className="text-sm text-slate-400 hover:text-brand-teal transition-colors">(11) 99868-6751</a></div>
              <div className="flex items-start gap-3"><Mail className="text-brand-teal mt-0.5 shrink-0" size={16} /><a href="mailto:comercial@dualibeneficios.com.br" className="text-sm text-slate-400 hover:text-brand-teal transition-colors">comercial@dualibeneficios.com.br</a></div>
              <div className="flex items-start gap-3"><Globe2 className="text-brand-teal mt-0.5 shrink-0" size={16} /><p className="text-sm text-slate-400">Atendimento Nacional</p></div>
            </div>
          </motion.div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <p className="text-center text-xs text-slate-500" data-testid="footer-copyright">&copy; {new Date().getFullYear()} Duali Soluções. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};
